import React, { useState } from 'react';
import {
    Button,
    Box,
    Typography,
    Paper,
    Stack,
    styled,
    LinearProgress,
    IconButton,
    Select,
    InputLabel,
    FormControl,
    MenuItem,
    Divider,
    InputAdornment,
    Tooltip
} from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import DeleteIcon from '@mui/icons-material/Delete';
import VideocamIcon from '@mui/icons-material/Videocam'; // ใช้ไอคอนสำหรับวิดีโอ
import { CloudUpload, Save, RestartAlt, LocationCity, InsertDriveFile, Image as ImageIcon } from '@mui/icons-material';
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx, subCardSx } from '../admin/AdminPageLayout';

// สร้าง input component ที่ซ่อนอยู่
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
// ข้อมูลอำเภอจำลอง
const districts = [
    { value: '1001', label: 'เมือง' },
    { value: '1002', label: 'บางใหญ่' },
    { value: '1003', label: 'สามพราน' },
    { value: '1004', label: 'ลำลูกกา' },
    { value: '1005', label: 'หาดใหญ่' },
];

function MainEditImagesAndVDO() {
    // image
    const [imageFile, setImageFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [selectedDistrictImg, setSelectedDistrictImg] = useState(''); // State เลือกอำเภอสำหรับรูปภาพ

    // vdo
    const [videoFile, setVideoFile] = useState(null);
    const [fileNamevdo, setFileNamevdo] = useState('');
    const [uploadingvdo, setUploadingvdo] = useState(false);
    const [progressvdo, setProgressvdo] = useState(0);
    const [selectedDistrictVdo, setSelectedDistrictVdo] = useState(''); // State เลือกอำเภอสำหรับวิดีโอ


    // ----------------- IMG ------------------ //
    const handleFileChangeImg = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageFile(file);
            setFileName(file.name);
            // รีเซ็ตสถานะการอัปโหลด
            setProgress(0);
            setUploading(false);
        }
    };

    const handleUploadImg = () => {
        if (!imageFile) return;

        setUploading(true);
        // จำลองการอัปโหลดไฟล์
        const interval = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    clearInterval(interval);
                    setUploading(false);
                    return 100;
                }
                const diff = Math.random() * 15;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);
    };

    const handleRemoveImg = () => {
        setImageFile(null);
        setFileName('');
        setProgress(0);
        setUploading(false);
    };
    // Handler สำหรับ Image
    const handleDistrictChangeImg = (event) => {
        setSelectedDistrictImg(event.target.value);
    };


    // ----------------- VDO ------------------ //
    const handleFileChangeVdo = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVideoFile(file);
            setFileName(file.name);
            setProgress(0);
            setUploading(false);
        }
    };

    const handleUploadVdo = () => {
        if (!videoFile) return;

        setUploading(true);
        // จำลองการอัปโหลดไฟล์วิดีโอ
        const interval = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    clearInterval(interval);
                    setUploading(false);
                    return 100;
                }
                const diff = Math.random() * 10; // อาจจะให้ progress ช้ากว่ารูปภาพเล็กน้อย
                return Math.min(oldProgress + diff, 100);
            });
        }, 800);
    };

    const handleRemoveVdo = () => {
        setVideoFile(null);
        setFileName('');
        setProgress(0);
        setUploading(false);
    };
    // Handler สำหรับ Video
    const handleDistrictChangeVdo = (event) => {
        setSelectedDistrictVdo(event.target.value);
    };


    return (
        <AdminPage
            icon={<PhotoCamera />}
            title="แก้ไขรูปภาพแบรนเนอร์อำเภอ"
            subtitle="เลือกอำเภอ แล้วอัปโหลดรูปภาพแบนเนอร์ใหม่เพื่อแทนที่รูปเดิม"
            maxWidth={760}
            actions={
                <>
                    <Button
                        variant="outlined"
                        color="inherit"
                        startIcon={<RestartAlt />}
                        onClick={handleRemoveImg}
                        sx={{ borderRadius: 3, width: { xs: '100%', sm: 'auto' } }}
                        disabled={uploading}
                    >
                        ยกเลิก
                    </Button>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<Save />}
                        onClick={handleUploadImg}
                        sx={primaryButtonSx}
                        disabled={!imageFile || uploading}
                    >
                        {uploading ? 'กำลังบันทึก...' : 'บันทึก'}
                    </Button>
                </>
            }
        >
            {/* -------------------- ① เลือกอำเภอ -------------------- */}
            <SectionTitle step={1} title="เลือกอำเภอ" />
            <FormControl fullWidth disabled={uploading}>
                <InputLabel id="district-select-img-label">เลือกอำเภอ</InputLabel>
                <Select
                    labelId="district-select-img-label"
                    id="district-select-img"
                    value={selectedDistrictImg}
                    label="เลือกอำเภอ"
                    onChange={handleDistrictChangeImg}
                    color="primary" // ใช้สีเขียวจาก theme
                    sx={{ borderRadius: 3 }}
                    startAdornment={
                        <InputAdornment position="start">
                            <LocationCity sx={{ color: GREEN }} />
                        </InputAdornment>
                    }
                >
                    {districts.map((district) => (
                        <MenuItem key={district.value} value={district.value}>
                            {district.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Divider sx={{ my: 3 }} />

            {/* -------------------- ② อัปโหลดรูปใหม่ -------------------- */}
            <SectionTitle step={2} title="อัปโหลดรูปภาพใหม่" />
            <Box
                sx={{
                    border: `2px dashed ${BORDER}`,
                    borderRadius: 3,
                    bgcolor: LIGHT,
                    p: 3,
                    textAlign: 'center',
                }}
            >
                <CloudUpload sx={{ fontSize: 48, color: GREEN }} />
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    เลือกไฟล์รูปภาพแบนเนอร์ (รองรับไฟล์รูปภาพทุกชนิด)
                </Typography>
                {/* ปุ่มอัปโหลดไฟล์ */}
                <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    tabIndex={-1}
                    startIcon={<PhotoCamera />}
                    sx={{ borderRadius: 3, color: GREEN, borderColor: GREEN, bgcolor: 'white' }}
                    disabled={uploading}
                >
                    อัปโหลดรูปภาพใหม่
                    <VisuallyHiddenInput type="file" accept="image/*" onChange={handleFileChangeImg} />
                </Button>
            </Box>

            {/* แสดงชื่อไฟล์และปุ่มลบ */}
            <Box sx={{ mt: 2 }}>
                {fileName ? (
                    <Paper variant="outlined" sx={{ ...subCardSx, p: 2 }}>
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <InsertDriveFile sx={{ color: GREEN }} />
                            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                <Typography variant="caption" color="text.secondary">ไฟล์ที่เลือก</Typography>
                                <Typography variant="body2" fontWeight={600} noWrap>{fileName}</Typography>
                            </Box>
                            <Tooltip title="ลบไฟล์">
                                <span>
                                    <IconButton
                                        aria-label="delete"
                                        onClick={handleRemoveImg}
                                        disabled={uploading}
                                        color="error"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Stack>
                    </Paper>
                ) : (
                    <Box sx={{ py: 3, textAlign: 'center', color: 'text.disabled' }}>
                        <ImageIcon sx={{ fontSize: 40 }} />
                        <Typography variant="body2">ยังไม่ได้เลือกไฟล์รูปภาพ</Typography>
                    </Box>
                )}
            </Box>

            {/* Progress Bar ขณะอัปโหลด */}
            {uploading && (
                <Box sx={{ width: '100%', mt: 2 }}>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        color="primary" // ใช้สีเขียวจาก theme
                        sx={{ height: 8, borderRadius: 4 }}
                    />
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                        กำลังอัปโหลด... {Math.round(progress)}%
                    </Typography>
                </Box>
            )}
                {/* <Grid item xs={12} md={6}> 
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            maxWidth: 500,
                            width: '100%',
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            variant="h5"
                            component="h1"
                            gutterBottom
                            align="center"
                            color="primary"
                            sx={{ fontWeight: 'bold' }}
                        >
                            แก้ไขวิดีโอ 🎥
                        </Typography>

                        <Stack spacing={2} mt={3}>
                            <FormControl fullWidth disabled={uploadingvdo}>
                                <InputLabel id="district-select-vdo-label">เลือกอำเภอ</InputLabel>
                                <Select
                                    labelId="district-select-vdo-label"
                                    id="district-select-vdo"
                                    value={selectedDistrictVdo}
                                    label="เลือกอำเภอ"
                                    onChange={handleDistrictChangeVdo}
                                    color="primary"
                                >
                                    {districts.map((district) => (
                                        <MenuItem key={district.value} value={district.value}>
                                            {district.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                startIcon={<VideocamIcon />}
                                color="secondary"
                                sx={{
                                    height: 56,
                                    backgroundColor: '#81C784',
                                    '&:hover': { backgroundColor: '#66BB6A' }
                                }}
                                disabled={uploadingvdo}
                            >
                                อัปโหลดไฟล์วิดีโอ
                                <VisuallyHiddenInput
                                    type="file"
                                    accept="video/*" // กำหนดให้รับเฉพาะไฟล์วิดีโอ
                                    onChange={handleFileChangeVdo}
                                />
                            </Button>

                            {fileNamevdo && (
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                    <Typography variant="body1" sx={{ flexGrow: 1, color: 'text.secondary' }}>
                                        ไฟล์ที่เลือก: **{fileNamevdo}**
                                    </Typography>
                                    <IconButton
                                        aria-label="delete"
                                        onClick={handleRemoveVdo}
                                        disabled={uploadingvdo}
                                        color="error"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            )}

                            {uploadingvdo && (
                                <Box sx={{ width: '100%', mt: 2 }}>
                                    <LinearProgress
                                        variant="determinate"
                                        value={progressvdo}
                                        color="primary"
                                    />
                                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                                        กำลังอัปโหลด... {Math.round(progressvdo)}%
                                    </Typography>
                                </Box>
                            )}

                            <Box sx={{ pt: 2, display: 'flex', gap: 2, justifyContent: 'center' }}>
                                <Button
                                    variant="outlined"
                                    onClick={handleRemoveVdo}
                                    sx={{ width: '50%' }}
                                    disabled={uploadingvdo}
                                >
                                    ยกเลิก
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleUploadVdo}
                                    sx={{ width: '50%' }}
                                    disabled={!videoFile || uploadingvdo}
                                >
                                    {uploadingvdo ? 'กำลังบันทึก...' : 'บันทึก'}
                                </Button>
                            </Box>
                        </Stack>
                    </Paper>

                </Grid> */}
        </AdminPage>
    )
}

export default MainEditImagesAndVDO